import * as React from "react";
import { Pivot, PivotItem, PivotLinkFormat, SearchBox } from "office-ui-fabric-react";
import styled from "styled-components";
import * as G from "~/components/global.style";
export interface Props
{
    
}

interface State
{
    
}



const Tabs = styled.div`
    height: 30px;
    .ms-Button{
        &:before{
            border-bottom: 0;
        }
        padding: 0px 10px;
        height: 30px;

        &:nth-child(1){
            background: #F2F2F2;
            padding: 0 20px;
        }
        &:nth-child(2){
            background: #F2F2F2;
            .ms-Pivot-icon{
                font-size: 25px;
                color: #990000;
            }
        }
        &:nth-child(3){
            background: #F2F2F2;
            .ms-Pivot-icon{
                font-size: 25px;
                color: #FF9900;
            }
        }
        &:nth-child(4){
            background: #F2F2F2;
            .ms-Pivot-icon{
                font-size: 25px;
                color: #009900;
            } 
        }
        &.is-selected{
            background: ${G.PrimaryColor}
        }        
    }

    .ms-Pivot-linkContent{
        display: flex;
        flex-direction: row-reverse;        
    }

    & + .ms-SearchBox {
        position: fixed;
        right: 30px;
        top: 35px;
        z-index: 11;
        flex-direction: row-reverse;
    }
`;

class Header extends React.Component<Props, State>
{
    getLocation = (path: string) =>
    {
        if (location.pathname.indexOf(path) !== -1)
        {
            return true;
        }
        return false;

    }


    getProductsMenu = () => 
    {
        return <><Tabs>
            <Pivot linkFormat={PivotLinkFormat.tabs}>
                <PivotItem linkText="All (289)" />
                <PivotItem linkText="New (265)" itemIcon="LocationDot" />
                <PivotItem linkText="Working (19)" itemIcon="LocationDot" />
                <PivotItem linkText="Ready (0)" itemIcon="LocationDot" />
            </Pivot>            
        </Tabs><SearchBox /></>;
    }

    getMediaMenu = () => 
    {
        return <><Tabs>
            <Pivot linkFormat={PivotLinkFormat.tabs}>
                <PivotItem linkText="Product Images" />
                <PivotItem linkText="In use images" />
                <PivotItem linkText="Technical drawings" />
                <PivotItem linkText="Product sheets" />
            </Pivot>            
        </Tabs><SearchBox /></>;
    }
    getTranslationsMenu = () => 
    {
        return <><Tabs>
            <Pivot linkFormat={PivotLinkFormat.tabs}>
                <PivotItem linkText="Terms" />
                <PivotItem linkText="Specifications"  />
                <PivotItem linkText="Extra equipment"  />
            </Pivot>            
        </Tabs><SearchBox /></>;
    }

    getMenu = () =>
    {
        if (this.getLocation("products"))
        {
            return this.getProductsMenu();
        }
        if (this.getLocation("media"))
        {
            return this.getMediaMenu();
        }
        if (this.getLocation("translations"))
        {
            return this.getTranslationsMenu();
        }
        return null;
    }

    render()
    {

        return (
            <div>
                {/*this.getMenu()*/}                
            </div>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/layout/Header.tsx